import React, { useState } from "react";
import "./Report.css";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaLongArrowAltLeft } from "react-icons/fa";
import Loading from "../Loader/Loading";
import myImage from "../../assets/183.png";

const Report = () => {
  const [filterdata, setfilterdata] = useState([]);
  const [filters, setfilters] = useState({
    category: "",
    support: "",
    startdate: "",
    enddate: "",
  });
  const [submittedFilters, setSubmittedFilters] = useState(null);

  const [dateError, setDateError] = useState("");
  const [showopenedOptions, setShowopenedOptions] = useState(false);
  const [showclosedOptions, setShowclosedOptions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const { users = [] } = location.state || {};

  const [isOpen1, setIsOpen1] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isreportopen, setisreportopen] = useState(false);

  const [currentPageOpened, setCurrentPageOpened] = useState(1);
  const [currentPageClosed, setCurrentPageClosed] = useState(1);
  const rowsPerPage = 10;

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const Navigate = useNavigate();

  const openedTickets = filterdata.filter(
    (filterdata) => filterdata.status !== "Closed"
  );

  const closedTickets = filterdata.filter(
    (ticket) => ticket.status === "Closed"
  );

  const filteredOpenedTickets = openedTickets.filter((filterdata) => {
    return userDetails.role === "cmanager"
      ? filterdata.client_id?.toString() === userDetails.clientid?.toString()
      : true;
  });

  const totalPagesOpened = Math.ceil(
    filteredOpenedTickets.length / rowsPerPage
  );
  const startIndexOpened = (currentPageOpened - 1) * rowsPerPage;
  const currentRowsOpened = filteredOpenedTickets.slice(
    startIndexOpened,
    startIndexOpened + rowsPerPage
  );

  const filteredClosedTickets = closedTickets.filter((ticket) => {
    return userDetails.role === "cmanager"
      ? ticket.client_id?.toString() === userDetails.clientid?.toString()
      : true;
  });

  const totalPagesClosed = Math.ceil(
    filteredClosedTickets.length / rowsPerPage
  );
  const startIndexClosed = (currentPageClosed - 1) * rowsPerPage;
  const currentRowsClosed = filteredClosedTickets.slice(
    startIndexClosed,
    startIndexClosed + rowsPerPage
  );

  const labelMap = {
    clientName: "Client Name",
    support: "Support Team",
    users: "Users",
    startdate: "Start Date",
    enddate: "End Date",
  };

  const handlehomepage = () => {
    Navigate("/CM");
  };

  const handleSubmit = () => {
    // Validate date range
    if (filters.startdate || filters.enddate) {
      if (!filters.startdate || !filters.enddate) {
        setDateError("Both start date and end date must be selected.");
        return;
      }

      if (new Date(filters.startdate) > new Date(filters.enddate)) {
        setDateError("Start date must be earlier than end date.");
        return;
      }

      setDateError("");
    } else {
      setDateError("");
    }

    handleFilterData();
  };

  const handleFilterData = async () => {
    if (
      filters.category ||
      filters.support ||
      (filters.startdate && filters.enddate)
    ) {
      setIsLoading(true);
      setisreportopen(true);
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/report.php`;
      const formData = new FormData();

      formData.append("category", filters.category || "");
      formData.append("assignedto_id", filters.support?.id || "");
      formData.append("start_date", filters.startdate || "");
      formData.append("end_date", filters.enddate || "");

      try {
        setfilterdata([]);

        const response = await fetch(apiUrl, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (data.data) {
          setSubmittedFilters(filters);

          setfilterdata(data.data);
        } else {
          setfilterdata([]);
        }
      } catch (error) {
        console.log("Error with POST request:", error);
        setfilterdata([]);
      } finally {
        setIsLoading(false);
      }
    } else {
      alert("Please enter all the required fields");
    }
  };

  const handleRemoveFilter = (keyToRemove) => {
    const updatedFilters = { ...filters, [keyToRemove]: "" };
    if (keyToRemove === "startdate" || keyToRemove === "enddate") {
      updatedFilters.startdate = "";
      updatedFilters.enddate = "";
    }
    setfilters(updatedFilters);
    setSubmittedFilters(updatedFilters);
  };

  const handleUserSelect = (selectedItem, type) => {
    setfilters((prevFilters) => ({
      ...prevFilters,
      [type]: { id: selectedItem.id, label: selectedItem.user_name },
    }));
  };

  const handlereportopened = async (type) => {
    // Validate required fields
    if (!filters.support?.id || !filters.startdate || !filters.enddate) {
      // Extract and encode values

      const category = encodeURIComponent(filters.category  || "");
      const supportId = encodeURIComponent(filters.support.id || "");
      const startDate = encodeURIComponent(filters.startdate || "");
      const endDate = encodeURIComponent(filters.enddate || "");
      const fileType = type === "pdf" ? "pdf" : "csv";

      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/reportopen.php?category=${category}&assignedto_id=${supportId}&start_date=${startDate}&end_date=${endDate}&type=${fileType}`;

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
        });

        const contentType = response.headers.get("Content-Type");

        if (!response.ok || !contentType.includes(fileType)) {
          const text = await response.text();
          console.error("Unexpected response:", text);
          alert("No data or wrong format returned.");
          return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `report-${filters.startdate}-${filters.enddate}.${fileType}`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Download error:", error);
        alert("There was an error downloading the report.");
      }
    }
  };

  const handlereportclosed = async (type) => {
    if (!filters.support?.id || !filters.startdate || !filters.enddate) {
      // Extract and encode values
      const category = encodeURIComponent(filters.category  || "");
      const supportId = encodeURIComponent(filters.support.id || "");
      const startDate = encodeURIComponent(filters.startdate || "");
      const endDate = encodeURIComponent(filters.enddate || "");
      const fileType = type === "pdf" ? "pdf" : "csv";

      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/reportclose.php?category=${category}&assignedto_id=${supportId}&start_date=${startDate}&end_date=${endDate}&type=${fileType}`;

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
        });

        const contentType = response.headers.get("Content-Type");

        if (!response.ok || !contentType.includes(fileType)) {
          const text = await response.text();
          console.error("Unexpected response:", text);
          alert("No data or wrong format returned.");
          return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `report-${filters.startdate}-${filters.enddate}.${fileType}`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Download error:", error);
        alert("There was an error downloading the report.");
      }
    }
  };

  return (
    <>
      <div className="align">
        <button className="button" onClick={handlehomepage}>
          <svg>
            <FaLongArrowAltLeft />
          </svg>
          <div className="text">Home</div>
        </button>
      </div>
      <div className="report-layout">
        <div className="sidebar">
          <h3>Selected Filters</h3>
          {submittedFilters ? (
            <ul className="filter-badges">
              {Object.entries(submittedFilters).map(([key, value]) => {
                if (!value) return null;
                const displayValue = value.label || value;
                return (
                  <li key={key} className="filter-badge">
                    <div>
                      <strong>{labelMap[key] || key}:</strong> {displayValue}
                    </div>
                    <button
                      className="remove-filter-btn"
                      onClick={() => handleRemoveFilter(key)}
                    >
                      &minus;
                    </button>
                  </li>
                );
              })}
            </ul>
          ) : (
            <p>No filters applied</p>
          )}
        </div>

        <div className="report-container">
          <h2 className="head">Report</h2>

          <div className="filter-section">
            <div className="date-range-group">
              <label className="date-label">Category</label>
              <select
                className="admin-portal-select"
                value={filters.category}
                onChange={(e) =>
                  setfilters((prevFilters) => ({
                    ...prevFilters,
                    category: e.target.value,
                  }))
                }
                required
              >
                <option value="" disabled selected>
                  Select Category
                </option>
                <option value="Salary">Salary</option>
                <option value="PF">PF</option>
                <option value="Insurance">Insurance</option>
                <option value="OT">OT</option>
                <option value="Offer Letter">Offer Letter</option>
                <option value="Releaving">Releaving</option>
                <option value="KYC">KYC</option>
                <option value="Others">Others</option>
              </select>
            </div>

            {/* Support Team Dropdown */}
            <div className="date-range-group">
              <label className="date-label">Support Team</label>
              <select
                className="admin-portal-select"
                value={filters.support?.id || ""}
                onChange={(e) =>
                  handleUserSelect(
                    users.find((u) => u.id === e.target.value),
                    "support"
                  )
                }
              >
                <option value="" disabled>
                  Select Support
                </option>
                {users
                  .filter((user) => user.role === "support")
                  .map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.user_name}
                    </option>
                  ))}
              </select>
            </div>

            {/* Date Filters */}
            <div className="date-range-group">
              <label
                //  htmlFor="startDate"
                className="date-label"
              >
                From
              </label>
              <input
                type="date"
                className="datePicker"
                name="startDate"
                id="startDate"
                value={filters.startdate}
                onChange={(e) =>
                  setfilters((prevFilters) => ({
                    ...prevFilters,
                    startdate: e.target.value,
                  }))
                }
              />
            </div>

            <div className="date-range-group">
              <label
                className="date-label"
              >
                To
              </label>
              <input
                type="date"
                className="datePicker"
                name="endDate"
                id="endDate"
                value={filters.enddate}
                onChange={(e) =>
                  setfilters((prevFilters) => ({
                    ...prevFilters,
                    enddate: e.target.value,
                  }))
                }
              />
            </div>

            {dateError && <div className="error-message">{dateError}</div>}
          </div>

          <div className="download-buttons">
            <div className="btn-submit-outer">
              <button
                className="btn-submit"
                // onClick={() => (handleSubmit(), setisreportopen(true))}
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>

          {isLoading && <Loading type="report" />}

          {isreportopen && (
            <>
              {filterdata.length === 0 ? (
                <div className="images">
                  <img src={myImage} alt="Description" />
                  <div className="notickets">
                    🔍 No Tickets found for the Matching Result.
                  </div>
                </div>
              ) : (
                <>
                  <div className="tickeet-summary">
                    <div className="ticket-card">
                      <span>Total Tickets:</span>
                      <span>
                        {
                          filterdata.filter((ticket) =>
                            userDetails.role === "cmanager"
                              ? ticket.client_id?.toString() ===
                                userDetails.clientid?.toString()
                              : true
                          ).length
                        }
                      </span>
                    </div>
                    <div className="ticket-card">
                      <span>UnAssigned Tickets:</span>
                      <span>
                        {
                          filterdata.filter(
                            (ticket) =>
                              ticket.status === "Un Assigned" &&
                              (userDetails.role === "cmanager"
                                ? ticket.client_id?.toString() ===
                                  userDetails.clientid?.toString()
                                : true) // show all if not cmanager
                          ).length
                        }
                      </span>
                    </div>
                    <div className="ticket-card">
                      <span>Assigned Tickets:</span>
                      <span>
                        {
                          filterdata.filter(
                            (ticket) =>
                              ticket.status === "Assigned" &&
                              (userDetails.role === "cmanager"
                                ? ticket.client_id?.toString() ===
                                  userDetails.clientid?.toString()
                                : true)
                          ).length
                        }
                      </span>
                    </div>
                    <div className="ticket-card">
                      <span>Opened Tickets:</span>
                      <span>
                        {
                          filterdata.filter(
                            (ticket) =>
                              ticket.status === "Opened" &&
                              (userDetails.role === "cmanager"
                                ? ticket.client_id?.toString() ===
                                  userDetails.clientid?.toString()
                                : true)
                          ).length
                        }
                      </span>
                    </div>
                    <div className="ticket-card">
                      <span>Hold Tickets:</span>
                      <span>
                        {
                          filterdata.filter(
                            (ticket) =>
                              ticket.status === "Hold" &&
                              (userDetails.role === "cmanager"
                                ? ticket.client_id?.toString() ===
                                  userDetails.clientid?.toString()
                                : true)
                          ).length
                        }
                      </span>
                    </div>
                    <div className="ticket-card">
                      <span>Closed Tickets:</span>
                      <span>
                        {
                          closedTickets.filter((ticket) =>
                            userDetails.role === "cmanager"
                              ? ticket.client_id?.toString() ===
                                userDetails.clientid?.toString()
                              : true
                          ).length
                        }
                      </span>
                    </div>
                  </div>

                  <div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <button
                        onClick={() => {
                          setIsOpen1(!isOpen1);
                          setIsOpen(false);
                        }}
                        style={{
                          background: "grey",
                          padding: "8px 16px",
                          borderRadius: "5px",
                          color: "white",
                          cursor: "pointer",
                        }}
                      >
                        PENDING TICKETS
                      </button>
                    </div>

                    <motion.div
                      initial={{ height: "auto", opacity: 1 }}
                      animate={{
                        height: isOpen1 ? "auto" : 0,
                        opacity: isOpen1 ? 1 : 0,
                      }}
                      transition={{ duration: 0.5 }}
                      style={{
                        overflow: "hidden",
                        background: " #f1f1f2",
                        padding: isOpen1 ? "10px" : "0px",
                        borderRadius: "5px",
                        marginTop: "10px",
                      }}
                    >
                      <div
                        className="download-wrapper"
                        onClick={() => setShowopenedOptions(true)}
                        onMouseLeave={() => setShowopenedOptions(false)}
                      >
                        <button className="downbtn">Download</button>
                        {showopenedOptions && (
                          <div className="download-actions">
                            <button onClick={() => handlereportopened("pdf")}>
                              PDF
                            </button>
                            <button onClick={() => handlereportopened("csv")}>
                              Excel
                            </button>
                          </div>
                        )}
                      </div>

                      <table className="report-table">
                        <thead>
                          <tr>
                            <th>SI.NO</th>
                            <th>Ticket Number</th>
                            <th>Error Title</th>
                            <th>Assigned Name</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentRowsOpened.length > 0 ? (
                            currentRowsOpened.map((item, index) => (
                              <tr key={item.id}>
                                <td className="tdh">
                                  {startIndexOpened + index + 1}.
                                </td>
                                <td>{item.ticketnumber}</td>
                                <td>{item.e_title}</td>
                                <td>{item.assname}</td>
                                <td>{item.status}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5">No data found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {totalPagesOpened > 1 && (
                        <div className="tdj">
                          <div>
                            <h2 className="tdk">
                              Page {currentPageOpened} of {totalPagesOpened}
                            </h2>

                            <div className="tdl">
                              {currentPageOpened !== 1 && (
                                <>
                                  <button
                                    className="tdm"
                                    onClick={() => setCurrentPageOpened(1)}
                                  >
                                    &laquo; First page
                                  </button>

                                  <button
                                    className="tdm"
                                    onClick={() =>
                                      setCurrentPageOpened((prev) =>
                                        Math.max(prev - 1, 1)
                                      )
                                    }
                                  >
                                    &lt; Previous
                                  </button>
                                </>
                              )}

                              {currentPageOpened !== totalPagesOpened && (
                                <>
                                  <button
                                    className="tdn"
                                    onClick={() =>
                                      setCurrentPageOpened((prev) =>
                                        Math.min(prev + 1, totalPagesOpened)
                                      )
                                    }
                                  >
                                    Next &gt;
                                  </button>

                                  <button
                                    className="tdo"
                                    onClick={() =>
                                      setCurrentPageOpened(totalPagesOpened)
                                    }
                                  >
                                    Last page &raquo;
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </motion.div>
                  </div>

                  <div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <button
                        onClick={() => {
                          setIsOpen(!isOpen);
                          setIsOpen1(false);
                        }}
                        style={{
                          background: "grey",
                          padding: "8px 16px",
                          borderRadius: "5px",
                          color: "white",
                          cursor: "pointer",
                        }}
                        // className="closed"
                      >
                        CLOSED TICKETS
                      </button>
                    </div>

                    <motion.div
                      initial={{ height: "auto", opacity: 1 }}
                      animate={{
                        height: isOpen ? "auto" : 0,
                        opacity: isOpen ? 1 : 0,
                      }}
                      transition={{ duration: 0.5 }}
                      style={{
                        overflow: "hidden",
                        background: " #f1f1f2",
                        padding: isOpen ? "10px" : "0px",
                        borderRadius: "5px",
                        marginTop: "10px",
                      }}
                    >
                      <div
                        className="download-wrapper"
                        onClick={() => setShowclosedOptions(true)}
                        onMouseLeave={() => setShowclosedOptions(false)}
                      >
                        <button className="downbtn">Download</button>
                        {showclosedOptions && (
                          <div className="download-actions">
                            <button onClick={() => handlereportclosed("pdf")}>
                              PDF
                            </button>
                            <button onClick={() => handlereportclosed("csv")}>
                              Excel
                            </button>
                          </div>
                        )}
                      </div>
                      <table className="report-table">
                        <thead>
                          <tr>
                            <th>SI.NO</th>
                            <th>Ticket Number</th>
                            <th>Error Title</th>
                            <th>Assigned Name</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentRowsClosed.length > 0 ? (
                            currentRowsClosed.map((item, index) => (
                              <tr key={item.id}>
                                <td className="tdh">
                                  {startIndexClosed + index + 1}.
                                </td>
                                <td>{item.ticketnumber}</td>
                                <td>{item.e_title}</td>
                                <td>{item.assname}</td>
                                <td>{item.status}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5">No data found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {totalPagesClosed > 1 && (
                        <div className="tdj">
                          <div>
                            <h2 className="tdk">
                              Page {currentPageClosed} of {totalPagesClosed}
                            </h2>

                            <div className="tdl">
                              {currentPageClosed !== 1 && (
                                <>
                                  <button
                                    className="tdm"
                                    onClick={() => setCurrentPageClosed(1)}
                                  >
                                    &laquo; First page
                                  </button>

                                  <button
                                    className="tdm"
                                    onClick={() =>
                                      setCurrentPageClosed((prev) =>
                                        Math.max(prev - 1, 1)
                                      )
                                    }
                                  >
                                    &lt; Previous
                                  </button>
                                </>
                              )}

                              {currentPageClosed !== totalPagesClosed && (
                                <>
                                  <button
                                    className="tdn"
                                    onClick={() =>
                                      setCurrentPageClosed((prev) =>
                                        Math.min(prev + 1, totalPagesClosed)
                                      )
                                    }
                                  >
                                    Next &gt;
                                  </button>

                                  <button
                                    className="tdo"
                                    onClick={() =>
                                      setCurrentPageClosed(totalPagesClosed)
                                    }
                                  >
                                    Last page &raquo;
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </motion.div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Report;
